import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { parentMenuFor } from "@/components/layout/adminNavMap";

// ESC (tastiera) e tasto in alto: tornano alla schermata di menu precedente (solo super_admin).
export function EscBackButton() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const target = parentMenuFor(pathname);
  useEffect(() => {
    const onKey = (e) => {
      if (e.key !== "Escape" || !target) return;
      // Non interferire con dialog/menu aperti o campi in scrittura.
      if (document.querySelector('[role="dialog"][data-state="open"], [role="menu"][data-state="open"], [data-radix-popper-content-wrapper]')) return;
      const tag = (e.target?.tagName || "").toLowerCase();
      if (["input", "textarea", "select"].includes(tag) || e.target?.isContentEditable) return;
      e.preventDefault();
      navigate(target);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [target, navigate]);
  if (!target) return null;
  return (
    <button
      type="button"
      onClick={() => navigate(target)}
      className="inline-flex items-center gap-1.5 h-9 px-3 rounded-xl border border-gray-200 bg-white text-xs font-bold text-gray-600 hover:text-[#1F1F1F] hover:border-gray-400"
      title="Torna al menu precedente (ESC)"
      data-testid="esc-back-btn"
    >
      <ArrowLeft className="w-3.5 h-3.5" /> Indietro <kbd className="text-[10px] border rounded px-1 bg-gray-50">ESC</kbd>
    </button>
  );
}
